import { getSilentFetch, postSilentFetch, putFetch } from 'request/request';
import { store } from 'redux/store';
import { setChatbotSettings } from 'pages/admin/sqp/chatbot-settings/chatbot-settings.slice';
import { ChatbotSettingsInterface } from 'interfaces/chatbot-settings.interface';

export const getChatbotSettings = async (values): Promise<ChatbotSettingsInterface[]> => {
  const res = await postSilentFetch('/sqp/admin/seller-settings/page', values);
  if (res) {
    store.dispatch(setChatbotSettings(res));
  }
  return res;
};

export const addChatbotSettings = async (values): Promise<ChatbotSettingsInterface> => {
  const res = await postSilentFetch('/sqp/admin/seller-settings', values);
  if (res) {
    store.dispatch(setChatbotSettings(res));
  }
  return res;
};

export const getChatbotSettingDetails = async (id): Promise<ChatbotSettingsInterface> => {
  const res = await getSilentFetch(`/sqp/admin/seller-settings/${id}`);
  return res;
};

export const updateChatbotSettings = async (id, values): Promise<ChatbotSettingsInterface> => {
  const res = await putFetch(
    `/sqp/admin/seller-settings/${id}`,
    { ...values, _id: id },
    'Setting Updated Successfully!'
  );
  return res;
};
